import React from 'react';

import { useQuery } from '@tanstack/react-query';

import BillPaymentsTable from '../../../../BillPaymentsTable';
import AddOrEditPageTabs from '../../../AddOrEditPageTabs';

import LoanService from '../../../../../services/LoanService';

const tabs = [
  {
    label: 'Bills',
  },
  {
    label: 'Bill Payments',
  },
];

export default function BillPayments({ isFetching, loanId }) {
  const { data: billPayments } = useQuery({
    queryKey: ['billPayments', loanId],
    queryFn: () => LoanService.getLoanBillPayments(loanId),
    enabled: !!loanId,
  });

  return (
    <div>
      <div className="mb-4 flex justify-between md:items-center flex-col md:flex-row gap-2 h-[37px]">
        <AddOrEditPageTabs tabs={tabs} />
      </div>
      <BillPaymentsTable
        isFetching={isFetching}
        loanId={loanId}
        billPayments={billPayments?._bill_payments}
      />
    </div>
  );
}
